import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, refreshSession } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  const check = useCallback(async () => {
    try {
      setUser((await api.get("/auth/me")).data);
    } catch {
      try {
        await refreshSession();
        setUser((await api.get("/auth/me")).data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    if (window.location.hash.includes("session_id=")) return; // AuthCallback exchanges it first
    check();
  }, [check]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
